export default __webpack_public_path__ + "static/media/tree_carzl.d5eeddde.png";